<template>
  <div class="page">
    <header class="page-header">
      <div>
        <h1>Encontros</h1>
        <p class="muted">Gerencie todos os encontros da igreja.</p>
      </div>
      <button class="btn-primary" @click="$router.push('/encontros/novo')">+ Novo encontro</button>
    </header>

    <div v-if="loading" class="card empty">Carregando...</div>

    <div v-else-if="erro" class="card empty erro-card">
      <p>{{ erro }}</p>
    </div>

    <div v-else-if="!encontros.length" class="card empty">
      <h3>Nenhum encontro cadastrado</h3>
      <p class="muted">Crie o primeiro encontro pra começar.</p>
      <button class="btn-primary" @click="$router.push('/encontros/novo')">+ Criar encontro</button>
    </div>

    <div v-else class="grid">
      <div v-for="e in encontros" :key="e.id" class="encontro-card card">
        <div class="encontro-color" :style="{ background: e.cor || '#94a3b8' }"></div>
        <div class="encontro-body">
          <div class="encontro-head">
            <h3>{{ e.nome }}</h3>
            <span class="status" :class="e.ativo ? 'ativo' : 'inativo'">{{ e.ativo ? 'ativo' : 'inativo' }}</span>
          </div>
          <p class="slug">
            <a :href="`https://${e.slug}.checkin.naelshaday.com.br`" target="_blank" rel="noopener">
              {{ e.slug }}.checkin.naelshaday.com.br ↗
            </a>
          </p>
          <p v-if="e.descricao" class="descricao">{{ e.descricao }}</p>
          <div class="counts">
            <span>{{ e._count?.participants ?? 0 }} participantes</span>
            <span>·</span>
            <span>{{ e._count?.admins ?? 0 }} admins</span>
          </div>
          <div class="actions">
            <button class="btn-secondary" @click="usuarios(e)">Usuários</button>
            <button class="btn-secondary" @click="editar(e)">Editar</button>
            <button class="btn-danger" @click="remover(e)" :disabled="removendoId === e.id">
              {{ removendoId === e.id ? 'Removendo…' : 'Remover' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../lib/api'

export default {
  name: 'EncontrosListPage',
  data() {
    return {
      encontros: [],
      loading: true,
      erro: '',
      removendoId: null
    }
  },
  async mounted() {
    await this.carregar()
  },
  methods: {
    async carregar() {
      this.loading = true
      this.erro = ''
      try {
        const { data } = await api.get('/encontros')
        this.encontros = data.encontros || []
      } catch (err) {
        this.erro = err.response?.data?.message || 'Falha ao listar encontros'
      } finally {
        this.loading = false
      }
    },
    editar(e) {
      this.$router.push(`/encontros/${e.id}/editar`)
    },
    usuarios(e) {
      this.$router.push(`/encontros/${e.id}/usuarios`)
    },
    async remover(e) {
      const confirmacao = window.prompt(
        `Pra remover "${e.nome}" digite o slug do encontro (${e.slug}). ` +
        `Isso apaga TODOS os participantes, admins e fotos deste encontro. Irreversivel.`
      )
      if (confirmacao !== e.slug) {
        if (confirmacao !== null) {
          this.$toast.open({ message: 'Slug incorreto, ação cancelada', type: 'warning', position: 'top-right' })
        }
        return
      }
      this.removendoId = e.id
      try {
        const { data } = await api.delete(`/encontros/${e.id}`)
        this.$toast.open({
          message: `Encontro removido (${data.photosDeleted ?? 0} fotos apagadas)`,
          type: 'success',
          position: 'top-right'
        })
        await this.carregar()
      } catch (err) {
        this.$toast.open({
          message: err.response?.data?.message || 'Falha ao remover',
          type: 'error',
          position: 'top-right'
        })
      } finally {
        this.removendoId = null
      }
    }
  }
}
</script>

<style scoped>
.page { max-width: 980px; margin: 0 auto; padding: var(--spacing-base); display: flex; flex-direction: column; gap: var(--spacing-base); }
.page-header { display: flex; justify-content: space-between; align-items: flex-end; gap: var(--spacing-base); flex-wrap: wrap; }
.page-header h1 { margin: 0 0 4px; }
.muted { color: var(--color-text-muted); margin: 0; }
.card { background: white; border-radius: var(--radius-md); border: 1px solid var(--color-border); }
.empty { padding: var(--spacing-lg); text-align: center; }
.empty h3 { margin: 0 0 8px; }
.erro-card { color: #b91c1c; background: #fee2e2; border-color: #fecaca; }
.grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: var(--spacing-base); }
.encontro-card { overflow: hidden; padding: 0; display: flex; flex-direction: column; }
.encontro-color { height: 6px; width: 100%; }
.encontro-body { padding: var(--spacing-base); display: flex; flex-direction: column; gap: 8px; }
.encontro-head { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
.encontro-head h3 { margin: 0; }
.status { font-size: 11px; padding: 2px 8px; border-radius: 99px; text-transform: uppercase; font-weight: 600; }
.status.ativo { background: #dcfce7; color: #14532d; }
.status.inativo { background: #f1f5f9; color: #475569; }
.slug { margin: 0; font-size: var(--text-sm); }
.slug a { color: var(--color-accent, #2563eb); text-decoration: none; }
.slug a:hover { text-decoration: underline; }
.descricao { color: var(--color-text-muted); margin: 0; font-size: var(--text-sm); }
.counts { display: flex; gap: 4px; color: var(--color-text-muted); font-size: var(--text-sm); }
.actions { display: flex; gap: 8px; margin-top: 8px; }
.btn-primary, .btn-secondary, .btn-danger { padding: 8px 14px; border-radius: var(--radius-md); font-weight: 500; cursor: pointer; border: 0; }
.btn-primary { background: #2563eb; color: white; }
.btn-secondary { background: #e2e8f0; color: #0f172a; }
.btn-danger { background: #dc2626; color: white; }
.btn-danger:disabled { opacity: 0.5; cursor: not-allowed; }
</style>
